import React, {useState} from "react";
import {setNavi} from "../../../@WUM/core/Function";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import GeneralSettings from "./components/GeneralSettings";
import {IntlMessageValue} from "../../../@WUM/core/component/const/IntlMessage";
import AutoClockOutSettings from "./components/AutoClockOutSettings";
import AutoBreakOutSettings from "./components/AutoBreakOutSettings";
import NotificationSettings from "./components/NotificationSettings";

const SettingsOverview = (value:any) => {
    setNavi({
        route: '/settings/worktime'
    })

    const [unsavedChanges, setUnsavedChanges] = useState(false);
    const [activeKey, setActiveKey] = useState("generalSettings");

    const handleTabSelect = (key: string | null) => {
        if (unsavedChanges && key !== activeKey) {
            /*if (!window.confirm("Es gibt ungespeicherte Änderungen. Trotzdem wechseln, ohne zu speichern?")) {
                return;
            }*/
        }
        if (key) {
            setActiveKey(key);
        }
    };


    return (
        <>
            <Tabs
                activeKey={activeKey}
                onSelect={handleTabSelect}
                className="mb-3"
            >
                <Tab eventKey="generalSettings" title={IntlMessageValue("", "time.settings.generalSettings", "")}>
                    <GeneralSettings onChangeUnsaved={setUnsavedChanges} />
                </Tab>
                <Tab eventKey="notifications" title={IntlMessageValue("", "Benachrichtigungen", "")}>
                    <NotificationSettings onChangeUnsaved={setUnsavedChanges} />
                </Tab>
                <Tab eventKey="autoclock" title={IntlMessageValue("", "Autoclock", "")}>
                    <AutoClockOutSettings onChangeUnsaved={setUnsavedChanges}/>
                </Tab>
                <Tab eventKey="autobreak" title={IntlMessageValue("", "Autobreak", "")}>
                    <AutoBreakOutSettings onChangeUnsaved={setUnsavedChanges}/>
                </Tab>
                <Tab eventKey="logs" title={IntlMessageValue("", "Logs", "")}>
                    <div></div>
                </Tab>
                <Tab eventKey="rights" title={IntlMessageValue("", "Rechte", "")}>
                    <div></div>
                </Tab>
                <Tab eventKey="other" title={IntlMessageValue("", "Sonstiges", "")}>
                    <div></div>
                </Tab>
            </Tabs>
        </>
    );
};

export default SettingsOverview;
